<template>
    <div id="app" class="container-fluid">
        <navbar @afterVideoSearch="afterVideoSearch" class="mb-2"></navbar>
        <main class="mb-4">
            <router-view />
        </main>
        <footer class="footer mt-auto py-4 bg-dark">
            <div class="container-fluid">
                <div class="float-left ml-4">
                    <img src="@/assets/img/logo-white.png" height="36" alt="">
                </div>
                <div class="float-right mt-2 mr-4">
                    <span class="text-white">© 2022</span>
                </div>
            </div>
        </footer>
        <notifications position="top center"></notifications>
    </div>
</template>

<script>
    import Navbar from '~/components/navbar';

    export default {
        name: 'app',
        components: { Navbar },
        data() {
            return {
                active: 0,
                videoPackageItem: {}
            };
        },
        created() {},
        methods: {
            afterVideoSearch(videoPackageItem) {
                this.videoPackageItem = videoPackageItem;
                console.log('afterVideoSearch in junior-student-cabinet', videoPackageItem);
            }
        }
    }
</script>

<style lang="scss">
    body {
        background: linear-gradient(to right, rgba(0, 157, 255, 0.25), rgba(114, 255, 0, 0.25)), url("./assets/img/bg-layer.png") no-repeat;
        background-size: 100%;
    }

    /*#app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }*/

    /* Fixed footer */
    html, body { height: 100% !important; }
    #app { display: flex !important; flex-direction: column !important; min-height: 100% !important; }
</style>
